import { action, computed, makeObservable, observable } from 'mobx';

import {
  CellControllerKind,
  NumberControllerEntity,
} from 'entities/TableControllers';

import { ITableControllerBase } from '../interface';

type PrivateFields = '_value';

export default class TableNumberControllerStore
  implements
    ITableControllerBase<NumberControllerEntity['controller']['value']>
{
  constructor(record: NumberControllerEntity) {
    this._value = record.controller;
    makeObservable<TableNumberControllerStore, PrivateFields>(this, {
      _value: observable.ref,
      controllerValue: computed,

      toServerFormat: computed,

      reset: action.bound,
    });
  }

  private _value: NumberControllerEntity['controller'];

  readonly isUpdateBlocked = false;

  get controllerKind() {
    return CellControllerKind.NUMBER;
  }

  get controllerValue() {
    return this._value;
  }

  get toServerFormat() {
    return this._value.value;
  }

  destroy() {}

  reset(): void {
    // do nothing
  }

  setValue(newValue: number): void {
    this._value = {
      ...this._value,
      value: newValue,
    };
  }
}
